module.exports = __webpack_public_path__ + "img/BE0462920226.638f2e1d.png";